import { render } from "./ListWarehouses.vue?vue&type=template&id=31ecebbc"
import script from "./ListWarehouses.vue?vue&type=script&lang=js"
export * from "./ListWarehouses.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "@/locales/views/service_provider/warehouse/movements/list_warehouses.yml?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Fnoe%2FDev%2Fatc%2Fagrotecchain_vue%2Fsrc%2Fviews%2Fservice_provider%2Fwarehouse%2Fmovements%2FListWarehouses.vue&lang=yaml"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/home/noe/Dev/atc/agrotecchain_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__